module.exports = __webpack_public_path__ + "img/tpc-26.f4e90b82.webp";